<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div v-if="formLabels.fields.benefitAction2" class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction2" id="benefitAction2" type="radio" />
                        <label for="benefitAction2">{{ formLabels.fields.benefitAction2 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
                <div v-else class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="checkbox" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
                <div class="col-12 col-lg-6" v-if="formLabels.fields.benefitAction2 && formData.benefit.action == formLabels.fields.benefitAction2">
                    <label for="dob">{{ formLabels.fields.benefitDate }}</label>
                    <date-picker v-model="formData.benefit.dateOfBirth" id="dob" format="DD/MM/YYYY" value-type="format"></date-picker>
                    <span class="form-field__error" v-if="$v.formData.benefit.dateOfBirth.$error">This field is required</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';

export default {
    props: {
        formLabels: {
            type: Object,
            required: true
        }
    },
    components: { DatePicker },
    inject: ['$v'],
    watch: {
        'formData.benefit': {
            handler: function(newVal) {
                if (!this.formLabels.fields.benefitAction2 && this.formData.benefit.action === true) {
                    this.formData.benefit.action = this.formLabels.fields.benefitAction1;
                }

                this.buildSummary(newVal);
            },
            deep: true
        },
    },
    computed: {
        ...mapGetters(['formData','formSummary']),
        formConditionals: {
            get() {
                return this.$store.state.formConditionals;
            }, 
            set(value) {
                this.$store.commit('updateFormConditionals',value);
            }
        },
        benefitFields() {
            return this.formSummary[1].fields;
        }
    },
    methods: {
        setConditionals() {
            // We need to store the full object paths for use in the core form
            this.formConditionals.action = function() { return !this.formLabels.fields.benefitAction2 };
        },
        buildSummary(fieldData) {
            let prettyLabels = {
                    action: 'Selection',
                    dateOfBirth: 'Date of Birth'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }
        },
    },
    mounted() {

        console.log(this.formData);

        this.formSummary.push({
            fields: {}
        });
    }
}
</script>